"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenScrollbar = exports.OverflownParent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.OverflownParent = styled_components_1.default.div `
  /* box model */
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
exports.HiddenScrollbar = styled_components_1.default.div `
  /* box model */
  box-sizing: border-box;
  overflow-y: auto;
  padding-right: ${({ scrollbarWidth }) => scrollbarWidth}px;
  width: calc(100% + ${({ scrollbarWidth }) => scrollbarWidth}px);
`;
